import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiFoodBeverageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_food_beverage"}/>
}
